module.exports = __webpack_public_path__ + "static/media/carbon.b1cc67b3.svg";